export default __webpack_public_path__ + "static/heroBg-b67c6927ddfc18c388d7e67e15cd6b4c.png";